import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { UserService } from 'src/app/services/user.service';
import { Favorite, PaginatedFavorites } from '../models/favorites.response';

const HTTP_OPTIONS_URLENCODED = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class FavoritesService {
  private readonly http = inject(HttpClient);
  private readonly apiService = inject(ApiService);
  private readonly userService = inject(UserService);

  getPaginatedFavorites(limit: number, offset: number): Observable<PaginatedFavorites> {
    const apiURL = `${this.apiService.API_URL}/patrons/${this.userService.getUserId()}/paginated-favorites`;

    const queryParams = {
      limit: limit,
      offset: offset,
      showExperiences: true,
    };

    return this.http.get<PaginatedFavorites>(apiURL, { params: queryParams });
  }

  postFavorite(favoriteId: string): Observable<Favorite> {
    const apiURL = `${this.apiService.API_URL}/patrons/${this.userService.getUserId()}/favorites`;

    const body = `resourceId=${favoriteId}`;

    return this.http.post<Favorite>(apiURL, body, HTTP_OPTIONS_URLENCODED);
  }

  deleteFavorite(favoriteId: string): Observable<Favorite[]> {
    const apiURL = `${this.apiService.API_URL}/patrons/${this.userService.getUserId()}/favorites`;

    const queryParams = {
      resourceId: favoriteId,
    };

    return this.http.delete<Favorite[]>(apiURL, { params: queryParams });
  }

  deleteAllFavorites(): Observable<Favorite[]> {
    const apiURL = `${this.apiService.API_URL}/patrons/${this.userService.getUserId()}/favorites`;

    return this.http.delete<Favorite[]>(apiURL);
  }
}
